import {useEffect} from 'react';

import {useTranslation} from 'react-i18next';

import {Box, Grid, Typography} from '@mui/material';

const HUBSPOT_SCRIPT_ID = 'hubspot-meetings-embed-script';
const HUBSPOT_SCRIPT_SRC = 'https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js';
const MEETING_LINK = process.env.REACT_APP_HUBSPOT_MEETING_LINK;

const injectHubspotScript = () => {
  const existingScript = document.getElementById(HUBSPOT_SCRIPT_ID) as HTMLScriptElement | null;

  if (existingScript) {
    return;
  }

  const script = document.createElement('script');
  script.id = HUBSPOT_SCRIPT_ID;
  script.src = HUBSPOT_SCRIPT_SRC;
  script.async = true;
  script.defer = true;
  document.body.appendChild(script);
};

export const HubspotCalendarSection = () => {
  const {t} = useTranslation();

  useEffect(() => {
    if (!MEETING_LINK) {
      return;
    }

    injectHubspotScript();
  }, []);

  return (
    <Grid
      id='hubspot-widget'
      width='100%'
      sx={{
        py: {xs: 4, md: 6},
        px: {xs: 2, md: 4},
        background: 'linear-gradient(180deg, #ffdeb3 0%, #f5f5f5 68.75%, #fffaf5 100%)',
      }}
    >
      <Typography
        sx={{
          color: '#163438',
          fontWeight: 700,
          fontSize: {xs: '2rem', sm: '2.25rem', md: '3rem'},
          lineHeight: 1.15,
          textAlign: 'center',
        }}
      >
        {t('b2b.results.hubspotCalendar.headline')}
      </Typography>

      <Typography
        sx={{
          mt: 1.5,
          color: '#163438',
          fontWeight: 400,
          fontSize: {xs: '1rem', md: '1.125rem'},
          lineHeight: 1.5,
          textAlign: 'center',
          maxWidth: '760px',
          mx: 'auto',
        }}
      >
        {t('b2b.results.hubspotCalendar.description')}
      </Typography>

      <Box
        sx={{
          mt: {xs: 3, md: 4},
          minHeight: {xs: 520, md: 700},
          width: '100%',
          maxWidth: 1120,
          mx: 'auto',
          borderRadius: '13px',
          backgroundColor: '#fff',
          overflow: 'hidden',
          boxShadow: '0px 3px 10px 0px rgba(0, 0, 0, 0.12)',
          p: {xs: 1, md: 2},
        }}
      >
        <Box
          component='div'
          className='meetings-iframe-container'
          data-src={MEETING_LINK}
          sx={{minHeight: {xs: 500, md: 660}}}
        />
      </Box>
    </Grid>
  );
};
